/**
 * Simple Toast Plugin for Vue 3
 */

const ToastPlugin = {
  install(app) {
    // Create toast container
    const createContainer = () => {
      let container = document.getElementById('toast-container')
      if (!container) {
        container = document.createElement('div')
        container.id = 'toast-container'
        container.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          gap: 8px;
          pointer-events: none;
        `
        document.body.appendChild(container)
      }
      return container
    }

    // Show toast
    const showToast = (message, type = 'info', duration = 3000) => {
      const container = createContainer()

      const toast = document.createElement('div')
      toast.style.cssText = `
        padding: 12px 20px;
        border-radius: 8px;
        color: white;
        font-size: 14px;
        font-weight: 500;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        pointer-events: auto;
        animation: slideIn 0.3s ease;
        max-width: 400px;
        word-break: keep-all;
      `

      // Set background color based on type (Modern Color Scheme)
      const colors = {
        success: '#059669',   // Emerald 600
        error: '#DC2626',     // Red 600
        warning: '#D97706',   // Amber 600
        info: '#4F46E5'       // Indigo 600 (Primary)
      }
      toast.style.backgroundColor = colors[type] || colors.info

      // Add icon
      const icons = {
        success: '✓',
        error: '✕',
        warning: '⚠',
        info: 'ℹ'
      }
      toast.innerHTML = `<span style="margin-right: 8px;">${icons[type] || icons.info}</span>${message}`

      container.appendChild(toast)

      // Add animation styles if not exists
      if (!document.getElementById('toast-styles')) {
        const style = document.createElement('style')
        style.id = 'toast-styles'
        style.textContent = `
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          @keyframes slideOut {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(100%);
              opacity: 0;
            }
          }
        `
        document.head.appendChild(style)
      }

      // Auto remove
      setTimeout(() => {
        toast.style.animation = 'slideOut 0.3s ease'
        setTimeout(() => {
          toast.remove()
        }, 300)
      }, duration)
    }

    // Create $toast object
    const toast = {
      success: (msg, duration) => showToast(msg, 'success', duration),
      error: (msg, duration) => showToast(msg, 'error', duration),
      warning: (msg, duration) => showToast(msg, 'warning', duration),
      info: (msg, duration) => showToast(msg, 'info', duration)
    }

    // Register globally
    app.config.globalProperties.$toast = toast
  }
}

export default ToastPlugin
